import { Flex } from '@servicetitan/anvil2';
import { useEffect, useState, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { LoadingScreen } from '@servicetitan/financing-utils-shared';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

interface PdfRendererProps {
    fileName?: string | null;
}

export const PdfRenderer = ({ fileName }: PdfRendererProps) => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const [containerWidth, setContainerWidth] = useState(window.innerWidth * 0.6);

    const onDocumentLoadSuccess = useCallback(({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setContainerWidth(width > 1024 ? 845 : width * 0.9); // Adjust width dynamically
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Flex
            style={{
                height: '100%',
                border: '1px solid #DFE0E1',
                overflowY: 'auto',
                minWidth: containerWidth,
                minHeight: containerWidth * 1.3, // This creates proportions of a Letter-sized page.
            }}
            alignSelf="stretch"
            lg={{ alignSelf: 'center' }}
            justifyContent="center"
        >
            <Document
                file={fileName}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={
                    <div style={{ alignSelf: 'stretch', flex: 1, paddingTop: '50px' }}>
                        <LoadingScreen message="Loading the document..." />
                    </div>
                }
            >
                {numPages &&
                    Array.from({ length: numPages }, (_, index) => (
                        <Page
                            key={index}
                            pageNumber={index + 1}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            width={containerWidth}
                            loading={
                                <div style={{ width: '100%', margin: '50px 0' }}>
                                    <LoadingScreen message="Loading the page..." />{' '}
                                </div>
                            }
                        />
                    ))}
            </Document>
        </Flex>
    );
};
